var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolyBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    strokeLinejoin: "bevel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M312 288L348 283L317 282Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 288L332 333L348 283Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 288L309 337L332 333Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309 337L320 351L332 333Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 351L342 352L332 333Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 333L399 312L348 283Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 263L376 264L399 312Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348 283L345 243L317 282Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 264L345 243L348 283Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 261L268 295L312 288Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 243L335 238L317 282Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399 312L376 264L348 283Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 264L358 209L345 243Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 242L312 288L317 282Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 288L268 295L309 337Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 389L339 387L320 351Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 352L399 312L332 333Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 261L261 297L268 295Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 295L261 297L309 337Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 238L290 242L317 282Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 387L367 363L342 352Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342 352L367 363L399 312Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 363L403 331L399 312Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 331L406 325L399 312Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399 312L414 276L383 263Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 242L263 261L312 288Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 238L289 231L290 242Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 242L289 231L263 261Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 312L414 276L399 312Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 209L340 210L345 243Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 243L340 210L335 238Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 389L320 351L309 337Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 351L339 387L342 352Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 209L376 264L383 263Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 238L287 219L289 231Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340 210L287 219L335 238Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 231L270 211L263 261Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 334L425 312L406 325Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406 325L425 312L399 312Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 311L425 312L428 334Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 204L358 209L383 263Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 334L406 325L403 331Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 312L431 283L414 276Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 232L239 274L263 261Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 261L239 274L261 297Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 390L296 389L309 337Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 390L309 337L251 385Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 389L334 399L339 387Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339 387L362 409L367 363Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 335L428 334L403 331Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 311L431 283L425 312Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414 276L427 246L383 263Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428 335L403 331L424 397Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 318L437 279L431 283Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 283L429 267L414 276Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 397L403 331L367 363Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 318L431 283L427 311Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 385L309 337L261 297Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 427L345 417L334 399Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 318L427 311L428 334Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 283L437 279L429 267Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 174L270 211L287 219Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287 219L270 211L289 231Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 174L287 219L340 210Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 232L225 284L239 274Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 274L225 284L261 297Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 230L427 246L444 231Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 267L427 246L414 276Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 246L390 204L383 263Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 209L356 187L340 210Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345 417L362 409L334 399Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 399L362 409L339 387Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 325L428 334L428 335Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 325L444 318L428 334Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 284L218 301L261 297Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 204L356 187L358 209Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 365L251 385L261 297Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 427L334 399L296 389Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 427L296 389L283 390Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 345L451 325L428 335Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 318L454 323L437 279Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 231L427 246L463 245Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 301L213 329L261 297Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 230L397 195L390 204Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 204L361 176L356 187Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 345L454 323L451 325Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 325L454 323L444 318Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 246L429 267L463 245Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 246L435 230L390 204Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 329L224 365L261 297Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 195L361 176L390 204Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 171L286 174L340 210Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218 301L206 330L213 329Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213 329L206 330L224 365Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 298L206 330L218 301Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 468L306 427L334 477Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 454L306 427L283 390Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 245L429 267L437 279Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 230L424 188L397 195Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 171L340 210L356 187Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 272L197 298L225 284Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 403L367 363L362 409Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 403L424 397L367 363Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 403L362 409L389 423Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 232L263 261L270 211Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 284L197 298L218 301Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 180L215 232L270 211Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 423L362 409L364 438Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 167L356 166L361 176Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361 176L356 166L356 187Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 166L288 171L356 187Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286 174L236 170L270 211Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 438L362 409L345 417Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 195L367 167L361 176Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 152L367 167L397 195Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 298L198 330L206 330Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206 330L198 330L224 365Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 397L465 345L428 335Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 249L463 245L475 255Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 245L437 279L475 255Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 199L424 188L435 230Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 468L364 438L345 417Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 199L435 230L444 231Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 255L437 279L497 296Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463 245L472 233L444 231Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497 296L437 279L454 323Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475 255L472 233L471 249Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 249L472 233L463 245Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 233L451 199L444 231Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 199L444 189L424 188Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 159L389 152L397 195Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 159L397 195L424 188Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367 167L350 140L356 166Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356 166L316 127L288 171Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 152L350 140L367 167Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 141L286 174L288 171Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 141L236 170L286 174Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 298L170 308L198 330Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198 330L180 384L224 365Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 272L170 308L197 298Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 272L225 284L215 232Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 308L171 327L198 330Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 454L283 390L251 385Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 468L376 457L364 438Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 438L376 457L389 423Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 423L430 437L419 403Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419 403L430 437L424 397Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 170L219 180L270 211Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 345L497 296L454 323Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 235L504 210L472 233Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 457L430 437L389 423Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 373L491 365L465 345Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465 345L525 321L497 296Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 445L251 385L210 435Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306 427L346 468L345 417Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 138L426 159L444 189Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 189L426 159L424 188Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 111L325 124L359 100Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 228L164 272L215 232Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 361L166 372L171 327Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 373L465 345L424 397Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 124L316 127L350 140Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350 140L316 127L356 166Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 385L489 373L500 399Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 372L180 384L198 330Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302 123L257 141L288 171Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236 170L212 156L219 180Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 127L350 140L389 152Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 127L302 123L288 171Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 457L412 457L389 423Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 399L489 373L478 431Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 500L412 457L376 457Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299 477L334 477L306 427Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346 468L366 484L376 457Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 445L243 454L251 385Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 111L379 127L389 152Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 119L302 123L316 127Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 480L299 477L306 427Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325 124L319 119L316 127Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 111L319 119L325 124Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 327L166 372L198 330Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 435L251 385L194 424Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 317L171 327L170 308Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251 385L224 365L194 424Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207 436L210 435L194 424Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 307L150 317L170 308Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 476L242 459L209 477Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 445L242 459L243 454Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243 454L278 480L306 427Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 200L215 232L219 180Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 200L163 228L215 232Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 272L136 307L170 308Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 496L425 458L412 457Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 457L425 458L430 437Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 424L224 365L180 384Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 435L207 436L224 445Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 459L194 424L180 384Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247 126L212 156L257 141Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 141L212 156L236 170Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 486L366 484L319 515Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 477L366 484L346 468Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 307L146 329L150 317Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 317L146 329L171 327Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 459L278 480L243 454Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 515L366 484L334 477Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 373L424 397L478 431Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489 373L500 385L491 365Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 365L525 321L465 345Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 100L325 124L350 140Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 119L316 102L302 123Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 121L247 126L257 141Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 111L371 114L379 127Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 127L371 114L350 140Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 491L334 477L299 477Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366 484L369 486L376 457Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 501L308 491L299 477Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 121L257 141L281 98Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472 233L504 210L451 199Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451 199L480 172L444 189Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 159L390 111L389 152Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 235L472 233L475 255Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 278L475 255L497 296Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 376L525 321L491 365Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 431L424 397L430 437Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 385L532 376L491 365Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 210L480 172L451 199Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 269L136 307L164 272Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 298L527 278L497 296Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 462L478 431L430 437Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 329L145 361L171 327Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 372L135 369L180 384Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 336L145 361L146 329Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 106L390 111L426 159Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 100L326 102L323 111Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 98L257 141L302 123Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185 133L188 143L200 119Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359 100L350 140L371 114Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323 111L316 102L319 119Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525 321L530 298L497 296Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 477L242 459L224 445Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 459L242 476L278 480Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278 480L292 501L299 477Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 488L242 476L238 504Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429 495L444 463L425 458Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 458L444 463L430 437Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 102L316 102L323 111Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 143L159 200L219 180Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 248L129 269L164 272Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 206L159 200L135 174Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378 99L359 100L371 114Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 39L281 98L316 102Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 307L132 336L146 329Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 172L456 138L444 189Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 462L480 441L478 431Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 431L518 409L500 399Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 248L164 272L163 228Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 307L116 322L132 336Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 488L292 501L278 480Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308 491L319 515L334 477Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 88L378 99L390 111Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390 111L378 99L371 114Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 82L316 102L326 102Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 477L224 445L190 465Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 476L246 488L278 480Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 82L326 102L359 100Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 102L281 98L302 123Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 143L219 180L212 156Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 200L146 206L163 228Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 409L519 391L500 399Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 399L519 391L500 385Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 297L549 286L530 298Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 286L530 235L527 278Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527 278L530 235L475 255Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 210L509 178L480 172Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480 172L491 130L456 138Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 336L135 369L145 361Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 361L135 369L166 372Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 465L224 445L207 436Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 463L464 462L430 437Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 413L532 376L519 391Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 500L464 462L444 463Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 520L397 500L369 486Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 486L397 500L376 457Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 206L127 248L163 228Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 308L116 322L136 307Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 156L247 126L200 119Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 143L212 156L200 119Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 409L478 431L480 441Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519 391L532 376L500 385Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 298L549 286L527 278Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 192L509 178L504 210Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397 500L420 496L412 457Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 523L319 515L292 501Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292 501L319 515L308 491Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 499L429 495L420 496Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 413L518 409L480 441Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 465L207 436L194 424Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 488L289 521L292 501Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 308L136 307L109 296Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 336L100 389L135 369Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553 297L530 298L525 321Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530 235L548 192L504 210Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 490L190 465L121 459Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 77L359 100L378 99Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 77L347 82L359 100Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415 91L385 88L390 111Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 279L136 307L129 269Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422 499L420 496L397 500Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 496L429 495L425 458Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 515L422 499L397 500Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 242L113 279L129 269Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 343L553 297L525 321Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 109L440 106L456 138Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456 138L440 106L426 159Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 476L483 462L464 462Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 462L483 462L480 441Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 103L247 126L248 121Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 143L135 174L159 200Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 91L248 121L281 98Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235 94L227 103L248 121Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 279L109 296L136 307Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114 308L108 304L116 322Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 439L524 413L480 441Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 409L524 413L519 391Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 282L549 286L553 297Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 229L116 242L127 248Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 248L116 242L129 269Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 279L85 289L109 296Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 229L127 248L146 206Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 88L353 77L378 99Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 82L326 39L316 102Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 39L353 77L352 22Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 103L200 119L247 126Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 296L108 304L114 308Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 322L100 389L132 336Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 106L415 91L390 111Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 542L238 504L209 477Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209 477L238 504L242 476Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 504L289 521L246 488Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319 515L386 520L369 486Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 521L297 523L292 501Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 72L244 91L281 98Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227 103L196 93L200 119Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 130L455 109L456 138Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440 106L460 76L415 91Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 500L444 463L429 495Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 558L386 520L319 515Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 91L235 94L248 121Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 178L491 130L480 172Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 176L110 229L146 206Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 252L85 289L113 279Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 296L85 289L108 304Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 500L484 476L464 462Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 462L546 439L480 441Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 515L429 495L422 499Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 176L135 174L131 109Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 125L135 174L188 143Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 520L425 515L397 500Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 174L129 176L146 206Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 125L188 143L185 133Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 515L462 500L429 495Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 93L168 125L200 119Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 119L168 125L185 133Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 207L548 192L530 235Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 178L532 156L491 130Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 207L530 235L598 271Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 271L530 235L549 286Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289 521L301 541L297 523Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297 523L301 541L319 515Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 520L409 600L425 515Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 542L301 541L289 521Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 179L532 156L548 192Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 192L532 156L509 178Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 252L116 242L110 229Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 252L113 279L116 242Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108 304L78 326L116 322Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 369L121 459L180 384Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 72L227 103L235 94Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 72L196 93L227 103Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229 72L235 94L244 91Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 515L471 505L462 500Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 500L471 505L484 476Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 478L546 439L483 462Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78 326L100 389L116 322Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238 504L275 542L289 521Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 542L275 542L238 504Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 496L209 477L190 465Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 0L229 72L281 98Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 255L86 252L51 210Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 304L81 302L85 289Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 289L81 302L108 304Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 562L314 550L301 541Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 541L314 550L319 515Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 552L515 542L471 505Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 459L190 465L194 424Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 304L78 326L81 302Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 302L78 326L108 304Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 478L483 462L484 476Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 413L580 402L532 376Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 91L455 109L491 130Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502 91L460 76L455 109Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 109L460 76L440 106Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 30L353 77L385 88Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353 77L326 39L347 82Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 207L560 179L548 192Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532 156L514 106L491 130Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 193L560 179L557 207Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598 271L549 286L599 282Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 508L164 496L163 490Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163 490L164 496L190 465Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 567L329 558L314 550Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314 550L329 558L319 515Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 30L385 88L415 91Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 179L549 152L532 156Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 200L86 252L110 229Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 252L72 255L85 289Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 389L121 459L135 369Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 472L121 459L92 455Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 567L293 562L275 542Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275 542L293 562L301 541Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 107L514 106L532 156Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 269L66 304L85 289Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 432L84 425L67 425Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 27L446 58L460 76Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460 76L446 58L415 91Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 282L553 297L600 300Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 179L557 141L549 152Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 300L553 297L600 343Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 343L525 321L532 376Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 439L580 402L524 413Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 316L600 276L599 282Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599 282L600 276L598 271Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 106L502 91L491 130Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 600L293 567L275 542Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 562L293 567L314 550Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 387L600 343L532 376Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 538L208 542L164 496Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 496L208 542L209 477Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 425L121 459L100 389Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 459L121 472L163 490Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 472L153 508L163 490Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 166L557 141L560 179Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549 152L557 141L532 156Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 106L514 77L502 91Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 193L557 207L600 220Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 27L389 30L415 91Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 93L149 93L168 125Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 125L131 109L135 174Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 176L60 200L110 229Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 66L149 93L196 93Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 47L196 93L229 72Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546 439L575 435L580 402Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 542L543 478L484 476Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 0L281 98L326 39Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 0L219 47L229 72Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 93L131 109L168 125Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 220L557 207L598 271Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 383L100 389L78 326Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 478L575 435L546 439Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 402L600 387L532 376Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389 30L352 22L353 77Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 210L55 269L72 255Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 255L55 269L85 289Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 304L43 330L78 326Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 141L534 107L532 156Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 16L420 27L446 58Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 238L600 220L598 271Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 166L559 136L557 141Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557 141L559 136L534 107Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149 93L128 106L131 109Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 109L128 106L129 176Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 99L128 106L149 93Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559 136L536 106L534 107Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534 107L514 77L514 106Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 391L600 387L580 402Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 300L614 316L599 282Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 276L629 238L598 271Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 343L614 316L600 300Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 426L614 316L600 343Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 567L336 583L329 558Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 558L362 600L386 520Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 505L515 542L484 476Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 600L336 583L327 608Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 6L334 16L352 22Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352 22L334 16L326 39Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 445L602 391L580 402Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 387L602 391L600 343Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 425L92 455L121 459Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 512L148 519L153 508Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 522L148 519L124 512Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153 508L164 538L164 496Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446 58L420 27L415 91Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 0L329 6L352 22Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 77L460 76L502 91Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 67L514 77L536 106Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536 106L514 77L534 107Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 512L153 508L121 472Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 519L164 538L153 508Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219 47L162 66L196 93Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 172L60 200L129 176Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 193L600 180L560 179Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559 136L566 98L536 106Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 220L600 189L588 193Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 238L600 189L600 220Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 98L122 99L118 90Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 106L54 172L129 176Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 330L66 304L0 292Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 304L43 330L0 292Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 425L73 432L92 455Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 425L84 425L100 389Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 522L164 538L148 519Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 542L207 566L275 542Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 90L122 99L149 93Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 99L120 98L128 106Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 66L151 69L149 93Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 50L151 69L162 66Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 383L67 425L100 389Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 506L121 472L80 479Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 160L600 180L631 170Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 189L600 180L588 193Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 0L352 22L389 30Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334 16L329 6L326 39Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 41L148 50L162 66Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 538L207 566L208 542Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 172L51 210L60 200Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 200L51 210L86 252Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 506L124 512L121 472Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 522L116 527L164 538Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 600L275 542L207 566Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 472L92 455L80 479Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 74L118 90L149 93Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 120L54 172L128 106Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 160L600 166L600 180Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 180L600 166L560 179Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 479L92 455L58 468Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 608L336 583L310 608Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336 583L362 600L329 558Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385 0L369 0L389 30Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 600L362 600L336 583Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 426L629 238L614 316Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 316L629 238L600 276Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 552L471 505L454 589Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 457L600 445L600 463Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575 435L600 445L580 402Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 0L385 0L420 27Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 27L385 0L389 30Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 445L575 435L600 463Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602 391L634 426L600 343Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 589L471 505L425 515Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43 330L38 383L78 326Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 468L92 455L73 432Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 386L38 383L43 330Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 -2L271 0L329 6Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 6L271 0L326 39Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 148L54 172L45 120Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 0L270 0L229 72Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 27L447 16L446 58Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 -27L270 -2L264 -48Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 0L270 -2L270 0Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 0L228 0L219 47Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 -2L329 6L264 -48Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349 600L344 636L362 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 608L336 583L293 567Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 110L566 98L559 136Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 77L491 27L460 76Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 600L310 608L293 567Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 439L73 432L67 425Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 600L257 600L275 542Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 600L207 566L234 618Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159 41L162 66L219 47Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 69L116 74L149 93Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 120L128 106L120 98Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 636L409 600L362 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362 600L409 600L386 520Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 618L207 566L176 630Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 600L234 618L310 608Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 527L148 522L124 512Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 23L159 41L219 47Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 636L333 611L327 608Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327 608L333 611L349 600Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 68L116 74L123 52Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 52L116 74L151 69Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 383L52 439L67 425Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 170L600 180L600 189Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 120L581 110L559 136Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 120L559 136L600 166Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 463L575 435L543 478Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 445L634 426L602 391Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 516L116 527L115 506Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 506L116 527L124 512Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 482L600 463L543 478Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586 86L543 67L566 98Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566 98L543 67L536 106Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 600L454 589L425 515Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 67L491 27L514 77Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 16L445 0L420 27Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 -2L228 0L270 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 228L16 260L51 210Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 210L16 260L55 269Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 604L438 600L409 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 600L438 600L454 589Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 52L151 69L148 50Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 74L112 68L118 90Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 52L148 50L125 28Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 339L24 386L43 330Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 383L8 420L52 439Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 0L171 23L219 47Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 27L445 0L447 16Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 -42L329 6L369 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 459L58 468L52 439Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 439L58 468L73 432Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 479L54 516L115 506Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 604L448 600L438 600Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438 600L448 600L454 589Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454 589L478 600L504 552Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 160L600 120L600 166Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581 110L586 86L566 98Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 -27L212 0L228 0Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228 0L212 0L219 47Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 28L148 50L159 41Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 486L600 482L583 509Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 463L613 466L603 457Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 482L543 478L583 509Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543 478L515 542L583 509Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 238L631 170L600 189Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612 160L631 170L600 120Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 509L515 542L563 559Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 482L613 466L600 463Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603 457L613 466L600 445Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 486L613 466L600 482Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 590L515 542L504 552Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 466L634 426L600 445Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629 238L662 0L631 170Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 606L453 604L487 626Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 600L453 604L454 589Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 444L45 459L52 439Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 468L54 516L80 479Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 120L120 98L118 90Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 225L9 228L51 210Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 120L118 90L112 68Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 225L51 210L0 194Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 292L66 304L55 269Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 194L51 210L0 186Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34L586 86L600 120Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 120L586 86L581 110Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 9L515 0L491 27Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 292L16 260L0 275Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 292L55 269L16 260Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 431L18 444L52 439Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 275L16 260L0 254Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 304L0 314L43 330Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166 4L158 16L171 23Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 23L158 16L159 41Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 254L16 260L9 228Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 626L453 604L409 600Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453 604L462 606L454 589Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254 600L234 618L257 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 608L344 636L327 608Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 611L344 636L349 600Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 600L207 566L164 538Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462 606L478 600L454 589Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 232L0 254L9 228Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 -27L179 0L212 0Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 0L179 0L171 23Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 618L344 636L310 608Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 -42L369 0L385 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 -2L246 -27L228 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -40L176 0L179 0Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179 0L176 0L171 23Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 7L112 68L123 52Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 60L45 120L112 68Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 186L51 210L54 172Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514 600L488 600L487 626Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 626L488 600L478 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 600L488 600L504 552Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 0L166 4L171 23Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158 16L125 28L159 41Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L0 314L0 304Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L-5 339L0 314Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 314L-5 339L43 330Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L0 304L-48 269Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 304L0 292L-48 269Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 600L510 590L504 552Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 9L125 28L158 16Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 135L31 131L44 60Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 120L31 131L38 148Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 225L-10 232L9 228Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 339L0 394L24 386Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 420L38 383L24 386Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 459L54 516L58 468Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 398L8 420L24 386Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 600L164 538L135 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 600L161 600L164 538Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 420L12 431L52 439Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 394L0 398L24 386Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 424L0 398L-32 406Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 590L563 559L515 542Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 509L600 527L600 486Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 486L663 486L613 466Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 159L54 172L38 148Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 254L-48 269L0 275Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 194L-10 232L9 225Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 -39L409 -42L445 0Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 0L409 -42L385 0Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 -39L445 0L491 27Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 559L593 533L583 509Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613 466L663 486L634 426Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 600L164 538L132 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161 600L176 630L207 566Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 131L11 159L38 148Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 181L0 186L54 172Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 194L-48 269L-10 232Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 9L491 27L543 67Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510 590L514 600L563 559Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 600L514 600L510 590Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 626L478 600L462 606Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 542L600 527L593 533Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593 533L600 527L583 509Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 524L54 516L45 459Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 159L0 181L54 172Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 186L-48 269L0 194Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 -42L264 -48L329 6Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 -27L112 -40L179 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 6L158 16L166 4Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 431L0 438L18 444Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 444L26 524L45 459Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 420L0 428L12 431Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 398L0 424L8 420Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 429L0 424L-32 406Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 429L0 428L0 424Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 424L0 428L8 420Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 0L539 9L543 67Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515 0L482 -39L491 27Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 406L0 398L0 394Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 428L0 438L12 431Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L0 394L-5 339Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 6L112 -40L105 -13Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 6L122 9L158 16Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 7L44 60L112 68Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 600L164 538L116 527Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 600L176 630L161 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 429L0 438L0 428Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L122 6L105 -13Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 7L123 52L125 28Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 600L132 600L116 527Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 600L176 630L152 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 636L487 626L409 600Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 561L593 533L563 559Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 561L600 542L593 533Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 561L563 559L582 586Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 527L663 486L600 486Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 625L176 630L135 600Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234 618L174 669L344 636Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 586L563 559L514 600Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 561L600 552L600 542Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 556L663 486L600 527Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 0L482 -39L515 0Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409 -42L600 -39L264 -48Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 131L0 135L11 159Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 159L0 135L0 181Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 181L-48 269L0 186Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 60L31 131L45 120Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48 269L0 254L-10 232Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48 269L0 292L0 275Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2 429L-32 406L0 438Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 7L125 28L122 9Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34L560 0L543 67Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539 9L560 0L515 0Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34L543 67L586 86Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 0L600 34L600 120Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 0L600 33L600 34Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 34L600 33L560 0Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L91 7L122 9Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L122 9L122 6Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L-32 406L0 394Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 438L26 524L18 444Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 555L26 524L0 438Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 516L35 555L116 527Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 6L166 4L112 -40Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 556L600 527L600 542Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634 426L663 486L629 238Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589 561L607 565L600 552Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 552L607 565L600 542Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 600L582 586L576 623Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 135L-48 269L0 181Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-38 335L-61 600L-32 406Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 586L607 565L589 561Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -40L166 4L176 0Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99 0L63 0L91 7Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 7L63 0L44 60Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 33L580 0L560 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 0L600 -39L482 -39Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 615L35 555L0 600Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 524L35 555L54 516Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 625L174 669L176 630Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 623L582 586L514 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 586L600 600L607 565Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607 565L650 556L600 542Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L595 0L600 33Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 33L595 0L580 0Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 0L600 -39L560 0Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 625L135 600L132 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 630L174 669L234 618Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 636L580 630L487 626Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 0L600 0L600 33Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595 0L600 -39L580 0Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 -13L63 0L99 0Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 60L-23 34L0 135Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 600L95 625L132 600Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 623L600 600L585 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585 600L600 600L582 586Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 -48L112 -40L246 -27Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105 -13L112 -40L63 0Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487 626L576 623L514 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 630L576 623L487 626Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 555L57 600L116 527Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 0L33 22L63 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 0L33 22L44 60Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 135L-23 34L-48 269Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 600L650 556L607 565Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642 600L607 565L600 600Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174 669L580 630L344 636Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 623L580 630L600 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -40L41 0L63 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -13L25 0L41 0Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 0L25 0L33 22Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 22L0 27L44 60Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0L0 27L33 22Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 630L642 600L600 600Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650 556L642 600L663 486Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662 0L600 -39L600 0Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600 0L600 -39L595 0Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482 -39L600 -39L409 -42Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 555L35 555L26 524Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 555L21 615L57 600Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 600L26 631L95 625Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95 625L26 631L174 669Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-26 0L-23 34L0 27Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27L-23 34L44 60Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 615L25 621L57 600Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 406L-33 555L0 438Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 630L26 631L25 621Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 600L-33 555L-32 406Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M663 486L662 0L629 238Z",
    fill: "#f8f9f8",
    stroke: "#f8f9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631 170L662 0L600 120Z",
    fill: "#fefffe",
    stroke: "#fefffe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -13L0 0L25 0Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 0L0 0L0 27Z",
    fill: "#f9faf9",
    stroke: "#f9faf9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 555L0 600L35 555Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 630L25 621L21 615Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 621L26 631L57 600Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 600L0 610L0 600Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 600L0 610L21 615Z",
    fill: "#f7f8f7",
    stroke: "#f7f8f7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 -40L0 -13L41 0Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L-26 0L0 27Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 634L11 630L0 610Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 610L11 630L21 615Z",
    fill: "#fbfcfb",
    stroke: "#fbfcfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 631L0 634L174 669Z",
    fill: "#f4f5f3",
    stroke: "#f4f5f3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -13L-26 0L0 0Z",
    fill: "#fcfdfc",
    stroke: "#fcfdfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23 34L-26 0L-48 269Z",
    fill: "#fdfefd",
    stroke: "#fdfefd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-61 600L0 634L0 610Z",
    fill: "#f6f7f5",
    stroke: "#f6f7f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 630L0 634L26 631Z",
    fill: "#fafbfa",
    stroke: "#fafbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48 269L-61 600L-38 335Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-33 555L-61 600L0 600Z",
    fill: "#f5f6f4",
    stroke: "#f5f6f4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyBg1);
export default __webpack_public_path__ + "static/media/polyBG1.15070efb9eb6b3dd88d32030e64f0afa.svg";
export { ForwardRef as ReactComponent };